import React, { PropsWithChildren, useContext } from 'react';
import { CellScope } from './Table.modifier';
import { createExtender } from '../../../lib/bemUtils/bem';
import { TableBodyContext } from './TableBody.context';

const tableHeaderClassExtender = createExtender('tables__tableheader');
const tableDataClassExtender = createExtender('tables__tabledata');

export type TableCell = {
  dataHead?: string;
  className?: string;
  id?: string;
  isTableHead?: boolean;
  isTableData?: boolean;
  scope?: CellScope;
  modifier?: any; // to afte th and td are refactored in its own components
  screenreaderOnly?: boolean;
  colSpan?: number;
  ariaSort?: 'descending' | 'ascending' | 'other';
  customTableHeaderClass?: string;
  customTableDataClass?: string;
};

/**
 * Renders a th or td
 * depending on context a th is rendered in a thead
 * in some special cases this can be overwritten via isTableData (mixed th)
 */
export function TableCell({
  colSpan,
  children,
  dataHead,
  id,
  isTableHead,
  isTableData,
  scope,
  screenreaderOnly,
  modifier,
  className = '',
  ariaSort,
  customTableHeaderClass,
  customTableDataClass,
}: PropsWithChildren<TableCell>) {
  const { isTableBody } = useContext(TableBodyContext);
  const cellClass = customTableHeaderClass || `${tableHeaderClassExtender(modifier)} ${className}`.trim();

  return !isTableData && (!isTableBody || isTableHead)
    ? (
        <th scope={scope || CellScope.COLUMN} id={id} colSpan={colSpan} className={cellClass} aria-sort={ariaSort}>
          {screenreaderOnly ? <span className="invisible">{children}</span> : children}
        </th>
      )
    : (
        <td
          id={id}
          colSpan={colSpan}
          className={customTableDataClass || `${tableDataClassExtender(modifier)} ${className}`.trim()}
          data-head={dataHead}
        >
          {screenreaderOnly ? <span className="invisible">{children}</span> : children}
        </td>
      );
}
